export enum BudgetRoutePathsEnum {
  BUDGET = '/budget',
}
